const transformFilterOption = (res) => {
    const results = res.results[0];
    return {
        TAGS: results.tags || [],
        RATING_OPTION: results.facets.reviewRatings || [],
        PROPERTY_TYPE: results.availableTypes || [],
        AVAILABLE_FACILITIES: results.availableFacilities || []
    };
};

export default transformFilterOption;
